<template>
    <AppLayoutBase>
        <template slot="main">
            <DashboardContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "EmployeeInterviewsEmployees",
    }
</script>

<style scoped>

</style>